import { DefaultPalette } from "@fluentui/react";
import { useContext } from "react";
import { TeamsFxContext } from "../components/Context";
import { THEME_MODE } from "../redux/constants/metaData";


export const useTheme = () => {

    const { themeString } = useContext(TeamsFxContext);

    const getColors = () => {
        switch (themeString) {
            case THEME_MODE.dark:
                return {
                    backgroundColor: "#1f1f1f",
                    tableBackgroundColor: "#1f1f1f",
                    themeColor: "#343434",
                    themeColorBackground: "#1f1f1f",
                    themeDarkColor: "#4C8D6A",
                    mainAreaBackgroundColor: "#1f1f1f",
                    fontColor: "#F5F5F5",
                    treeSelectColor: "#3D7A59",
                    /* fontColor: "#FFF5F5F5",*/
                    themeFontColor: "#EFF1EF",
                    deactiveFontColor: "#FFFFFF",
                    borderColor: "#EEEEEE",
                    addovationWhite: "FBFBFB",
                    addovation05Grey: "#F8F8F8",
                    addovation10Grey: "#EEEEEE",
                    addovation30Gray: "#A7A7A7",
                    addovation20Green: "#C1DBBB",
                    addovation50Green: "#71AD8D",
                    addovation70Green: "#4C8D6A",
                    addovation90Green: "#387E58",
                    Addovation20Grey: "#DCDCDC",
                    deactiveColorLight: "#DCDCDC",
                    deactiveColor: "#A7A7A7",
                    themeColor20: "#C1DBBB",
                    themeColor50: "#71AD8D",
                    themeColor90: "#387E58",
                    titleColor: "#232323",
                    subTitle: "#B9B9B9",
                    buttonTextColor: "#FFFFFF",
                    selectedObjectConnectionTextColor: "#232323",
                    validationColor: "#FF5C5C",
                    tableCellSeperator: "#F7F7F7",
                    msTeamsFilesHover: "#343434",
                    contextMenuHover: "#4A4A4A",
                    defaultBlack: "#000000",
                    modelHeaderColor: "#249F5D",
                    contextMenuBackground: "#343434",
                    scrollbarBackground: "#525252",
                    scrollbarThumb: "#848484",
                    sideBarFont: "#6C6C6C",
                    cancleBtnDisable: "#505050",
                    toolBarBtnDisable: "#515151",
                    pureColor: "#000000",
                    dividerColor: "#A4A4A4",
                    progressBar: "#446946",
                    progressBarBackground: "#515151",
                    popupDialogBackgroundColor: "#2B2B2B",
                    viewCopyAccordianBorderColor: "#FFFFFF",
                    viewCopyUploadTextColor: "#969696",
                    disableDropDownColor: "#323232",
                    dropDownSelectColor:"#3A3A3A",
                    navSelectedBackground: "#343434",
                    navSelectedStroke: "#4C8D6A",
                    addovationMainBtnColor: "#4c8d6a",
                    dialogBackgroundColor: "#1f1f1f",
                    tableHeaderBg: "#2B2B2B",
                    dialogBorderColor: "#3A3A3A",
                    dialogCloseBg: "#4C8D6A",
                    dialogCloseText: "#FFFFFF",
                    dialogCloseBorder: "#4C8D6A",
                    dialogCloseHoverBg: "#3D7A59",
                    dialogCloseHoverBorder: "#3D7A59",
                };
            case THEME_MODE.default:
                return {
                    backgroundColor: DefaultPalette.white,
                    tableBackgroundColor: "#f5f5f5",
                    themeColor: "#DFECDC",
                    themeColorBackground: "#EEF4EF",
                    themeDarkColor: "#4C8D6A",
                    treeSelectColor: "#E2F7E2",
                    mainAreaBackgroundColor: "",
                    fontColor: "#2F2F2F",
                    themeFontColor: "#000000",
                    deactiveFontColor: "#FFFFFF",
                    borderColor: "#EEEEEE",
                    addovationWhite: "FBFBFB",
                    addovation05Grey: "#F8F8F8",
                    addovation10Grey: "#EEEEEE",
                    addovation30Gray: "#A7A7A7",
                    addovation20Green: "#C1DBBB",
                    addovation50Green: "#71AD8D",
                    addovation70Green: "#4C8D6A",
                    addovation90Green: "#387E58",
                    Addovation20Grey: "#DCDCDC",
                    deactiveColorLight: "#DCDCDC",
                    deactiveColor: "#A7A7A7",
                    themeColor20: "#C1DBBB",
                    themeColor50: "#71AD8D",
                    themeColor90: "#387E58",
                    titleColor: "#232323",
                    subTitle: "#616161",
                    buttonTextColor: "#FFFFFF",
                    selectedObjectConnectionTextColor: "#232323",
                    validationColor: "#FF5C5C",
                    tableCellSeperator: "#F7F7F7",
                    msTeamsFilesHover: "#EBEBEB",
                    contextMenuHover: "#E2EFDF",
                    defaultBlack: "#000000",
                    modelHeaderColor: "#249F5D",
                    contextMenuBackground: DefaultPalette.white,
                    scrollbarBackground: DefaultPalette.white,
                    scrollbarThumb: "#ccc",
                    sideBarFont: "black",
                    cancleBtnDisable: "#DBDBDB",
                    toolBarBtnDisable: "#C6C5C5",
                    pureColor: "#FFFFFF",
                    dividerColor: "#C4C4C4",
                    progressBar: "#AFCDB1",
                    progressBarBackground: "#E9E9E9",
                    popupDialogBackgroundColor: DefaultPalette.white,
                    viewCopyAccordianBorderColor: "#DCDCDC",
                    viewCopyUploadTextColor: "#000000",
                    disableDropDownColor: "#F1F1F1",
                    dropDownSelectColor:"#EDEBE9",
                    navSelectedBackground: "#EEF4EF",
                    navSelectedStroke: "#C1D4C7",
                    addovationMainBtnColor: "#4c8d6a",
                    dialogBackgroundColor: "#FFFFFF",
                    tableHeaderBg: "#F9FAFB",
                    dialogBorderColor: "#E5E7EB",
                    dialogCloseBg: "#FFFFFF",
                    dialogCloseText: "#57A77A",
                    dialogCloseBorder: "#57A77A",
                    dialogCloseHoverBg: "#F7FCF8",
                    dialogCloseHoverBorder: "#4A9A6C",
                };
            default:
                return DefaultPalette.white;
        }
    };


    const currentTheme = {
        colors: getColors(),
        // {
        //   backgroundColor: DefaultPalette.white,
        //   themeColor: "#E2EFDF",
        //   themeDarkColor: "#4C8D6A",
        //   mainAreaBackgroundColor: "",
        //   fontColor: "#2F2F2F",
        //   darkthemeFontColor: "#D9DAD9",
        //   deactiveFontColor: "#FFFFFF",
        //   borderColor: "#EEEEEE",
        //   addovationWhite: "",
        //   addovation05Grey: "#F8F8F8",
        //   addovation10Grey: "#EEEEEE",
        //   addovation30Gray: "#A7A7A7",
        //   addovation20Green: "#C1DBBB",
        //   addovation50Green: "#71AD8D",
        //   addovation70Green: "#4C8D6A",
        //   addovation90Green: "#387E58",
        //   Addovation20Grey: "#DCDCDC",
        //   deactiveColorLight: "#DCDCDC",
        //   deactiveColor: "#A7A7A7",
        //   themeColor20: "#C1DBBB",
        //   themeColor50: "#71AD8D",
        //   themeColor90: "#387E58",
        //   titleColor: "#232323",
        //   subTitle: "#616161",
        //   buttonTextColor: "#FFFFFF",
        //   selectedObjectConnectionTextColor : "#232323",
        //   validationColor: "#FF5C5C",
        //   tableCellSeperator: "#F7F7F7",
        //   msTeamsFilesHover: "#EBEBEB"
        // },
        fonts: {
            regular: "Poppins, sans-serif",
            bold: "Poppins Bold, sans-serif",
        },
        /** Fluent ContextualMenu item text (Details, Check-out, …) */
        contextMenu: {
            fontSize: 12,
            fontFamily: "Poppins, sans-serif",
        },
        fontSizes: {
            normal: 12,
            extraMedium: 13,
            menusize: 12,
            medium: 16,
            large: 18,
            xLarge: 20,
        },
        fontWeight: {
            normal: 400,
            menuWeight: 500,
            titleWeight: 600,
        },
        fontStyle: {
            normal: "normal",
        },
        lineHeight: {
            lable: 20,
            grid: 20,
            header: 22,
            small: 16,
        },
        mainLayout: {
            backgroundColor: "#1f1f1f",
        },
        fontFace: {
            normal: "normal",
        },
        paggination: {
            colors: {
                current: "#E5E3E3",
                disable: "#1f1f1f",
                button: "#E5E3E3",
                active: "#E5E3E3",
            },
            fontFamily: "Poppins, sans-serif",
            lineHeight: "24px",
            fontSize: "16px",
        },
        dropDown: {
            colors: {
                title: "#71AD8D",
                border: "#DCDCDC",
            },
        },
        border: {
            colors: {
                title: "#71AD8D",
                border: "#DCDCDC",
            },
            radius: {
                textField: "8px",
                button: "25px",
            },
        },
    };
    return currentTheme;
};

